import {
  Box,
  Container,
  Stack,
  Typography,
  alpha,
  useTheme,
} from '@mui/material';
import { ArrowForward } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

import {
  StyledButton,
  getTransitionStyle,
} from '../../components/Utils/UIUtils';
import WorldWide from '../../assets/images/world-wide.png';

export default function Section1() {
  const theme = useTheme();
  const { t } = useTranslation();

  const arrowTransitionStyle = getTransitionStyle(theme, ['transform']);
  return (
    <Container
      component="section"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        gap: '48px',
        py: { xs: 6, sm: 8, md: 10 },
      }}
      maxWidth="lg"
    >
      <img
        src={WorldWide}
        alt="World Wide"
        style={{
          maxWidth: '100%',
          maxHeight: '256px',
          minWidth: '200px',
        }}
        loading="lazy"
      />
      <Stack gap={2}>
        <Box component="header">
          <Typography variant="h2" sx={{ fontSize: '32px', fontWeight: '600' }}>
            {t('HOME_PAGE.SECTION1.TITLE')}
          </Typography>
        </Box>
        <Typography
          variant="body1"
          sx={{
            color: 'text.secondary',
            fontSize: '16px',
            fontWeight: '300',
          }}
        >
          {t('HOME_PAGE.SECTION1.PARAGRAPHS.0')}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: 'text.secondary',
            fontSize: '16px',
            fontWeight: '300',
          }}
        >
          {t('HOME_PAGE.SECTION1.PARAGRAPHS.1')}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: 'text.secondary',
            fontSize: '16px',
            fontWeight: '300',
          }}
        >
          {t('HOME_PAGE.SECTION1.PARAGRAPHS.2')}
        </Typography>
        <StyledButton
          variant="contained"
          size="large"
          href="/free-trial"
          sx={{
            alignSelf: 'center',
            bgcolor: alpha(theme.palette.primary.main, 0.1),
            color: theme.palette.primary.main,
            p: '12px 24px',
            fontWeight: '400',
            fontSize: '16px',
            '&:hover .MuiButton-endIcon ': {
              transform: 'translateX(4px)',
              ...arrowTransitionStyle,
            },
            '& .MuiButton-endIcon': {
              ...arrowTransitionStyle,
            },
            '&:hover': {
              bgcolor: theme.palette.primary.main,
              color: theme.palette.common.white,
            },
          }}
          endIcon={<ArrowForward />}
        >
          {t('HOME_PAGE.SECTION1.BUTTON')}
        </StyledButton>
      </Stack>
    </Container>
  );
}
